import styled from 'styled-components';
import {styledByDevice} from '../../../../themes/architecture/styled-by-device';

const DefaultBox = styled.div`
    flex-grow: 1;
    color: ${props => props.theme.colors.textLight};
    font-family: ${props => props.theme.font.family.body};
    line-height: normal;
    text-transform: capitalize;
    font-size: 1.4em;
    letter-spacing: 0.98px;
`;


const PcBox = styled(DefaultBox)`
    text-align: center;
`;

const MobileBox = styled(DefaultBox)`
    text-align: left;
`;

export const DialogTitleDefaultBox = styledByDevice(PcBox, MobileBox);